import "vant/es/list/style";
import _List from "vant/es/list";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-41ef1b32"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ask-list"
};
const _hoisted_2 = {
  class: "answer-head-wrap"
};
const _hoisted_3 = {
  class: "title"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 进行中");

const _hoisted_5 = {
  class: "switch"
};
import AskCell from '@/components/ask/ask-cell.vue';
import composition from '@/composition'; // import { defineEmits } from 'vue'

export default {
  props: {
    tagId: String
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      request
    } = composition();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const count = ref(-1); // const emit = defineEmits(['initCount'])
    // 排序方式

    let orders = ['hotCount', ''];
    const listType = ref(1);
    let page = 1;

    const onLoad = () => {
      request.getPostList({
        tagId: props.tagId,
        type: 'ASK',
        order: orders[listType.value],
        page
      }).then(res => {
        loading.value = false;

        if (res.data.length == 0) {
          finished.value = true;
        }

        page++;
        list.value = list.value.concat(res.data);

        if (count.value == -1) {
          count.value = res.pageData.total;
        }
      });
    }; // 修改排序方式


    const changeType = type => {
      listType.value = type; // 清空列表数据

      finished.value = false; // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态

      loading.value = true;
      list.value = [];
      page = 1;
      count.value = -1;
      onLoad();
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("p", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, "共" + _toDisplayString(count.value) + "个提问", 1)], 512), [[_vShow, count.value >= 0]]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: _normalizeClass(listType.value == 1 ? 'select' : ''),
        onClick: _cache[0] || (_cache[0] = $event => changeType(1))
      }, "最新", 2), _createElementVNode("div", {
        class: _normalizeClass(listType.value == 0 ? 'select' : ''),
        onClick: _cache[1] || (_cache[1] = $event => changeType(0))
      }, "最热", 2)])]), _createVNode(_unref(_List), {
        loading: loading.value,
        "onUpdate:loading": _cache[2] || (_cache[2] = $event => loading.value = $event),
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return _openBlock(), _createBlock(AskCell, {
            key: item.id + '-' + index,
            item: item
          }, null, 8, ["item"]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished"])]);
    };
  }

};